
import "./details.coffee"
